import { render } from "./PasoResumen.vue?vue&type=template&id=3fc8ea64&scoped=true"
import script from "./PasoResumen.vue?vue&type=script&lang=js"
export * from "./PasoResumen.vue?vue&type=script&lang=js"

import "./PasoResumen.vue?vue&type=style&index=0&id=3fc8ea64&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc8ea64"]])

export default __exports__